import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import $ from 'jquery';
import { Link, useHistory } from 'react-router-dom';
import { UploadArea } from '../../../_common/upload-area';
import * as R from 'ramda';
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import contriesList from 'iso-3166-1-alpha-2';
import { createDeathDeclaration, updateDeathDeclaration, uploadDocument, downloadDocument, deleteDocument } from './../../../../actions/facilita-api';
import { RegexFields } from './../../../../constants/utils/regexFields';
import { DateWithModal } from '../../../../_common/dateWithModal';
import { PostalCityInput } from "../../../../_common/postalCityInput";

import DeathDeclaration from '../../../../constants/models/facilita/deathDeclaration';
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';
import { FileTypes } from './../../../../constants/utils/fileTypes';

export const Step1 = ({ user, deceasedUser, files, isLoading }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    registerLocale("fr", fr);
    const history = useHistory();
    const dispatch = useDispatch();
    //const user = useSelector(state => state.user);
    const identForm = useRef(null);
    const [deathCertificateUploadAlert, setDeathCertificateUploadAlert] = useState(false);
    const [deathCertificateUploadError, setDeathCertificateUploadError] = useState(false);
    const [identFields, setIdentFields] = useState(new DeathDeclaration({
        ...user,
        firstName: deceasedUser.firstName,
        lastName: deceasedUser.lastName
    }));

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    let deathCertificate = files.find(f => f.fileType === FileTypes.DeathCertificate);
    return (
			<article className="view-calc pt-3 mb-auto">
				<div className="container-fluid">
					<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
						<h1 className="text-primary font-weight-bolder mt-2 mb-3">Déclarer le décès de votre proche</h1>
						{/* <h2 className="text-body ls-0 mt-n2 o-50">Vous pouvez dès à présent effectuer la déclaration</h2> */}
					</header>
				</div>
				<div className="auto-view scroll-auto py-4 pb-lg-0">
					<div className="container-fluid">
						<section className="block mb-gutter">
							<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-0">téléchargement obligatoire</h4>
							<form className="flex-column py-sm g-sm-3" noValidate ref={identForm}>
								{/* <UploadArea documentName="Certificat de décès" uploadedFile={getDocument("Certificat de décès")} /> */}
								<div className="flex-column gx-2">
									<div className="block mb-3">
										<h5 className="h5 text-uppercase font-weight-bolder mb-2 sr-only" htmlFor="lieudeces">
											Donnes de Défunt
										</h5>
										<div className="form-row">
											<div className="col-12 col-xl-6 form-row">
												<div className="form-group col-12 col-md">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"Nom"}>
														Nom
													</label>
													<input
														required
														type="text"
														className="form-control"
														id={"Nom"}
														onChange={(e) => {
															setIdentFields({ ...identFields, lastName: e.target.value });
														}}
														value={identFields.lastName}
														pattern={RegexFields.nameWithoutNumbers}
													/>
												</div>
												<div className="form-group col-12 col-md">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"Prenom"}>
														Prénom
													</label>
													<input
														required
														type="text"
														className="form-control"
														id={"Prenom"}
														onChange={(e) => {
															setIdentFields({ ...identFields, firstName: e.target.value });
														}}
														value={identFields.firstName}
														pattern={RegexFields.nameWithoutNumbers}
													/>
												</div>
											</div>
											<div className="col col-md-4 col-hd-3 form-group">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"naissance"}>
													Date de décès
												</label>
												<DateWithModal selectedDate={identFields.deathDate} setSelectedDate={(d) => setIdentFields({ ...identFields, deathDate: d })} isRequired={true} />
											</div>
										</div>
									</div>
									<div className="block">
										<h5 className="h5 text-uppercase font-weight-bolder mb-2" htmlFor="lieudeces">
											Lieu du décès
										</h5>
										<div className="form-row">
											<div className="form-group col-12 col-md-6">
												<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
													Adresse
												</label>
												<input
													required
													type="text"
													className="form-control"
													id="Adresse"
													value={identFields.userDeceasedAddress.addressLine1}
													onChange={(event) => {
														setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, addressLine1: event.target.value } });
													}}
												/>
											</div>
                                            <PostalCityInput
													postalCode={identFields.userDeceasedAddress.postalCode}
													city={identFields.userDeceasedAddress.city}
													onChange={(updatedAddress) => setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
													hasWrapper={false}
													country={identFields.userDeceasedAddress.country}
													customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
												/>
											{/* <div className="form-group col-12 col-sm"> 
                                                 <label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
													Code Postal
												</label>
												{identFields.country === null || identFields.country === "FR" || identFields.country === "GF" || identFields.country === "PF" || identFields.country === "TF" ? (
													<input
														required
														type="text"
														className="form-control"
														id="Postal"
														value={identFields.userDeceasedAddress.postalCode}
														onChange={(event) => {
															setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, postalCode: event.target.value } });
														}}
														pattern={RegexFields.frenchZipCode}
													/>
												) : (
													<input
														required
														type="text"
														className="form-control"
														id="Postal"
														value={identFields.userDeceasedAddress.postalCode}
														onChange={(event) => {
															setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, postalCode: event.target.value } });
														}}
													/>
												)}
											</div>
											<div className="col-12 d-xl-none"></div>
											<div className="form-group col-12 col-sm">
												<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
													Ville
												</label>
												<input
													required
													type="text"
													className="form-control"
													id="Ville"
													defaultValue={identFields.userDeceasedAddress.city}
													onChange={(event) => {
														setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, city: event.target.value } });
													}}
													pattern={RegexFields.nameWithoutNumbers}
												/>
											</div> */}
											<div className="form-group col-12 col-sm">
												<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
													Pays
												</label>
												<select
													className="custom-select"
													id="naturalite"
													tabIndex={-98}
													value={R.isNil(identFields.userDeceasedAddress.country) ? "FR" : identFields.userDeceasedAddress.country}
													onChange={(event) => {
														setIdentFields({ ...identFields, userDeceasedAddress: { ...identFields.userDeceasedAddress, country: event.target.value } });
													}}>
													{Object.keys(contriesList.getData()).map((country, index) => {
														return (
															<option key={index} value={country}>
																{countries.getName(country, "fr", { select: "official" })}
															</option>
														);
													})}
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="flex-md-row gx-0 gx-md-2">
									<div className="flex-column col-md-4 mb-2 mb-md-0">
										<UploadArea
											documentName="Acte de décès"
											uploadedFile={deathCertificate}
											uploadFile={(document, description) => {
												dispatch(uploadDocument(deceasedUser.id, FileTypes.DeathCertificate, document, description))
													.catch((error) => {
														if (error.response && error.response.status === 400) {
															setDeathCertificateUploadError(true);
														}
													});
												setDeathCertificateUploadAlert(false);
												setDeathCertificateUploadError(false);
											}}
											downloadFile={(document) => dispatch(downloadDocument(deceasedUser.id, document.fileName))}
											deleteFile={(document) => dispatch(deleteDocument(deceasedUser.id, document.fileName))}
											autoupload={true}
										/>
										<div className={"invalid-feedback alert-danger alert" + (deathCertificateUploadAlert ? " d-block" : "")}>Veuillez charger un document</div>
										<div className={"invalid-feedback alert-danger alert" + (deathCertificateUploadError ? " d-block" : "")}>Le fichier est invalide. Veuillez réessayer ou consulter la FAQ si le problème persiste.</div>
									</div>
									<div className="card alert-primary text-body my-2 mt-sm-0 mb-sm-auto" style={{ position: 'relative', zIndex: 0 }}>
										<div className="card-body d-flex align-items-start">
											<i className="eva eva-alert-triangle text-primary mr-2 h3 mt-n1"></i>
											<div className="flex-grow-1">
												<h1 className="small font-weight-bolder text-primary text-uppercase">Attention</h1>
												<p className="small o-70 lh-copy mb-3">En déposant l'acte de décès, vous vous engagez à déposer un document authentique sous peine de 5 ans de prison et 75 000 € d’amende.</p>
												<p className="small o-70 lh-copy mb-1">
													En déposant l'acte de décès <b>lisible</b>, vous acceptez d’être le référent principal des démarches de votre proche. Afin de vous faciliter et de vous soulager dans toutes ces démarches, les courriers seront établis avec votre adresse et votre signature. Vous n'aurez plus qu'à confirmer et
													valider l’envoi.
												</p>

												<div className="form-group mt-3">
													<div className="custom-control custom-switch">
														<input type="checkbox" className="custom-control-input" id="customSwitch1" required defaultChecked={user.onBoardingStep > 3} />
														<label className="custom-control-label" htmlFor="customSwitch1">
															Je déclare sur l'honneur que les informations ci-dessus sont véridiques.
														</label>
													</div>
													<div className={"invalid-feedback"} id="customSwitch1InvalidFeedback">
														Veuillez confirmer la véracité des informations fournies.
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</section>
					</div>

					<div className="container-fluid">
						<footer className="d-block mt-auto mb-sm text-right w-100">
							<Link to="/facilita" className="btn btn-faded px-md-gutter mr-3">
								Fermer
							</Link>
							{/* <Link to="/facilita/:user/declarer/step2" className="btn btn-info px-md-gutter px-4">Passer à l'étape suivante</Link> */}
							{isLoading.includes(loadings.UPDATING_DECLARATION) || isLoading.includes(loadings.CREATING_DECLARATION) ? (
								<button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">
									Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
								</button>
							) : (
								<button
									type="button"
									className="btn btn-info px-md-gutter px-4"
									onClick={async (event) => {
										event.preventDefault();

										if (R.isNil(identFields.deathDate) || identFields.deathDate > new Date()) {
											document.getElementById("date-modal").setCustomValidity("Invalid value");
										} else {
											document.getElementById("date-modal").setCustomValidity("");
										}

										identForm.current.classList.add("was-validated");
										if (!document.getElementById("customSwitch1").checked) {
											document.getElementById("customSwitch1InvalidFeedback").classList.add("d-block");
										}
										if (R.isNil(deathCertificate)) {
											setDeathCertificateUploadAlert(true);
											return;
										}

										if (identForm.current.checkValidity()) {
											if (R.isNil(identFields.id) || identFields.id === "") {
												dispatch(createDeathDeclaration(deceasedUser.id, { ...identFields, allocations: identFields.allocations, professionalSituation: "" })).then(() => history.push(`/facilita/${deceasedUser.id}/declarer/step2`));
											} else {
												dispatch(updateDeathDeclaration(deceasedUser.id, identFields)).then(() => history.push(`/facilita/${deceasedUser.id}/declarer/step2`));
											}
										}
									}}>
									Passer à l'étape suivante
								</button>
							)}
						</footer>
					</div>
				</div>
			</article>
		);
};